export default {
  name: 'login',
  created () {
    if (window.localStorage.getItem('access_token')) {
      this.authorize()
    }
  },
  data: function () {
    return {
      loginId: '',
      password: '',
      keepLogin: true,
      app_type: 'master'
    }
  },
  computed: {
    error () {
      return this.$store.getters.authError || this.$store.getters.apiError
    },
    isStaging () {
      return process.env.NODE_ENV == 'staging' ? true:false
    }
  },
  methods: {
    authorize: function() {
      this.$store.dispatch('AUTHORIZE', {callback: this.authOk})
    },
    authOk: function (result) {
      this.$router.push('/')
    },
    login: function() {
      var formData = new FormData();
      formData.append('user[login_id]', this.loginId);
      formData.append('user[password]', this.password);
      this.$store.dispatch('LOGIN', {data: formData, keepLogin: this.keepLogin})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/login.js